module.exports = __webpack_public_path__ + "static/img/invite-earth.730701f.png";